import React from 'react'
import { useNavigate } from 'react-router-dom'
import usePostXbox from '../../api/v1/auth/usePostXbox'
import { useAuth } from '../../providers/auth'
import { FirstPartyPlatformType } from '../../types/Account'
import AuthCallback from '../AuthCallback'

const XboxAuthCallback: React.FC = () => {
  const navigate = useNavigate()
  const authContext = useAuth()

  return (
    <AuthCallback
      usePostAuth={usePostXbox}
      onSuccess={(xboxAuthResponse) => {
        authContext.setAuthToken(xboxAuthResponse.jwt, {
          username: xboxAuthResponse.gamertag.modern,
          suffix: xboxAuthResponse.gamertag.modern_suffix,
        })
        navigate('/')
      }}
      platform={FirstPartyPlatformType.XBOXLIVE}
    />
  )
}

export default XboxAuthCallback
